const Footer = () => {
    return (
        <footer>
            <div className="footer">
                <p>© 2025 / {new Date().getFullYear()} Tax Low Prices. All rights reserved.</p>
            </div>
        </footer>
    )
}
export default Footer;